import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ChatsService } from '../../../services/chats/chats.service';

@Component({
  selector: 'tl-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListComponent implements OnInit, OnDestroy {
  
  @Input() list: string[];
  @Input() text: string = 'ChatsService';
  @Input() buildId: number = null;
  @Input() userAdmin: boolean = false;
  @Output() goToComplaint = new EventEmitter<any>();
  @Output() chatInit = new EventEmitter<any>();

  constructor(
    private chatsService: ChatsService
  ) {}

  ngOnInit() {
    this.chatInit.emit();
    
    this.setDefaultScId();

    this.chatsService.lastServerResponse.subscribe(val => {
      if (val?.data?.comppaintId) {
        this.chatsService.lastServerResponse.next(null);
        this.goToComplaint.emit(val.data.comppaintId);
      }
    });

    this.chatsService.myMessage = this.text;

    this.chatsService.buildingId = this.buildId;
    this.chatsService.userAdmin = this.userAdmin;
    
  }

  setDefaultScId() {
    if (!localStorage.getItem('SC_ID')) {
      localStorage.setItem('SC_ID', '1');
    }
  }

  ngOnDestroy(): void {
    console.warn('ListComponentDestroy');
  }
}
